/**
 * Constantes et utilitaires pour la gestion du polling
 */

// Intervalle de polling en millisecondes (30 secondes)
export const POLLING_INTERVAL = 30000;

/**
 * Fonction utilitaire de debounce pour éviter les appels API multiples
 *
 * @param {Function} fn - Fonction à debouncer
 * @param {number} delay - Délai en millisecondes
 * @returns {Function} - Fonction debouncée
 */
export const debounce = (fn, delay) => {
    let timeoutId;

    return function(...args) {
        // Annuler le timeout précédent si existe
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        // Créer un nouveau timeout
        timeoutId = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
};
